module.exports = __webpack_public_path__ + "img/flag_sa.4c86b15b.png";